export default __webpack_public_path__ + "static/media/bg3.3ab32cf1.png";